import { Spinner } from "./spinner";

export const LoadingBox = ({ message }: { message?: string }) => {
	return (
		<div className="flex flex-col gap-4 w-full h-full items-center justify-center text-center max-w-2xl mx-auto py-8">
			<Spinner className="w-16 h-16 self-center" />
			<h1 className="font-bold text-4xl">Loading</h1>
			{message && <p className="text-sm text-primary/50">{message}</p>}
		</div>
	);
};
